module.exports = __webpack_public_path__ + "70c078a3c4315b2f6fc96fea19ce0f20.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/lawbreakers/mammoth.png
// module id = 1071
// module chunks = 0